module.exports = __webpack_public_path__ + "static/media/departure_board_black_24dp.6b3d6c0d.svg";